import axios from "axios";

const url = `${process.env.AGW_EMPLEO_SERVICES_API_URL}`;
const apikeyIntegraciones = `${process.env.AGW_EMPLEO_SERVICES_API_KEY}`;
const newTokenizer = process.env.URL_TOKENIZER;

const getToken = async () => {
    const data = await axios.post(
        `${newTokenizer}`,
        {'action': 'getJWT'},
        {
            headers: {
                Apikey: process.env.URL_TOKENIZER_APIKEY,
                Origin: process.env.URL_TOKENIZER_ORIGIN,
                "Content-Type": "application/json",
            },
        }
    );
    return data;
};

const getCatalogData = async () => {
    const token = await getToken();
    const data = await axios.get(
        `${url}comfama/aira/api/v1/aira-data-exchange/get-catalog-data`,
        { 
          headers : {Authorization: token.data.data.id_token, apikey: apikeyIntegraciones}
        }
    );
    return data;
}

const getCandidatesByFilter = async (queryParameters) => {
    const token = await getToken();
    const fullURL = url + "comfama/aira/api/v1/aira-data-exchange/get-candidates-by-filter";
    const data = await axios.get(
                    `${queryParameters ?  fullURL + "?" + queryParameters : fullURL}`,
                    {
                        headers: { Authorization: token.data.data.id_token, apikey: apikeyIntegraciones }
                    }
                );
    return data;
};

const saveProfile = async (rqbody) => { //Se va a eliminar con el nuevo servicio
    const token = await getToken();
    const data = await axios.post(
                    `${url}comfama/aira/api/v1/aira-data-exchange/save-home-perfil`,
                    rqbody,
                    {headers: { Authorization: token.data.data.id_token, apikey: apikeyIntegraciones } }
                );
    return data;
};

const getProfileByDocnum = async (docNumber) => {
    const token = await getToken();
    const data = await axios.get(
                    `${url}comfama/aira/api/v1/aira-data-exchange/get-candidates-by-docnum`,
                    { params: {
                        "docNumber": docNumber
                    },
                    headers: { Authorization: token.data.data.id_token, apikey: apikeyIntegraciones } }
                );
    return data;
};

const getCatalogDataPerPersonas = async () => {
    const token = await getToken();
    const data = await axios.get(
        `${url}comfama/aira/api/v1/aira-data-exchange/get-home-perfil-catalog`,
        { 
            headers : {
                Authorization: token.data.data.id_token,
                Apikey: apikeyIntegraciones,
            }
        }
    );
    return data;
}

const saveProfileVideo = async (rqBody, cedula) => {
    const token = await getToken();
    const data = await axios.post(
        `${url}comfama/aira/api/v1/aira-data-exchange/upload-to-s3?cedula=${cedula}`,
        rqBody,
        {
            headers: {
                Authorization: token.data.data.id_token,
                apikey: apikeyIntegraciones,
                'Content-Type': 'multipart/form-data',
            }
        }
    );
    return data;
}

const getS3File = async (s3key) => {
    const token = await getToken();
    const data = await axios.get(
        `${url}comfama/aira/api/v1/aira-data-exchange/get-s3-file?s3ObjectKey=${s3key}`,
        { 
          headers : {Authorization: token.data.data.id_token, apikey: apikeyIntegraciones}
        }
    );
    return data;
}

const getS3Url = async (s3key) => {
    const token = await getToken();
    const data = await axios.get(
        `${url}comfama/aira/api/v1/aira-data-exchange/get-s3-url?s3ObjectKey=${s3key}`,
        { 
          headers : {Authorization: token.data.data.id_token, apikey: apikeyIntegraciones}
        }
    );
    return data;
}

const getProfileData = async (cedula) => {
    const token = await getToken();
    const data = await axios.get(
        `${url}comfama/aira/api/v1/usuario/${cedula}`,
        {
            headers: {
                Authorization: token.data.data.id_token,
                apikey: apikeyIntegraciones,
            }
        }
    );
    return data;
}

const generateCv = async (id) => {
    const data = await axios.get(
        `${url}comfama/aira/api/v1/usuario/generate/cv/${id}`,
        {
            responseType: 'arraybuffer',
        }
    );
    
    return data;
}

const saveProfileData = async (rqbody) => {
    const token = await getToken();
    const data = await axios.post(
                    `${url}comfama/aira/api/v1/usuario/save`,
                    rqbody,
                    { 
                        headers : {
                            Authorization: token.data.data.id_token,
                            apikey: apikeyIntegraciones,
                            "Content-Type": "application/json",},
                    }
                );
    return data;
};

export { 
    getToken,
    getCatalogData, 
    getCandidatesByFilter,
    saveProfile,
    getProfileByDocnum,
    getCatalogDataPerPersonas,
    saveProfileVideo,
    getS3File,
    getS3Url,
    getProfileData,
    generateCv,
    saveProfileData
};
